import {Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, OnInit, Output,} from '@angular/core';
import {CriteriaStoreService} from '../../services/criteria-store.service';
import {
    DsBoxModule,
    DsButtonModule,
    DsCheckboxModule,
    DsColumnData,
    DsFormFieldModule,
    DsIconModule,
    DsLoadingAreaConfiguration,
    DsLoadingAreaModule,
    DsLoadingAreaService,
    DsModalModule,
    DsPopoverModule,
    DsProgressCircleModule,
    DsSelectModule,
    DsTableModule,
    DsToastModel,
    DsToastService,
    SelectListOption,
} from '@bmw-ds/components';
import {CommonModule} from '@angular/common';
import {CriteriaService} from '../../services/criteria.service';
import {CriteriaResponse, DealerModel, Version,} from '../../models/criteria.model';
import {DemoStockRowData} from '../../models/demo-stock-row.model';
import {DemoVehiclesRequest} from '../../models/demo-request.model';
import {FormsModule} from '@angular/forms';
import {DemoService} from '../../services/demo.service';
import {StockResponse} from '../../models/stock-response.model';
import {StockItem} from '../../models/stock-item.model';
import {RequestVehicleRequest} from '../../models/request-vehicle.model';
import {ReplenishmentService} from '../../services/replenishment.service';
import {UserInfoService} from '../../services/user-info.service';
import {COMMON_IMPORTS} from "../../shared/common-imports";

@Component({
  selector: 'app-demo-stock-filters',
    imports: [
        DsCheckboxModule,
        DsFormFieldModule,
        DsSelectModule,
        DsLoadingAreaModule,
        FormsModule,
        DsButtonModule,
        DsTableModule,
        DsPopoverModule,
        DsBoxModule,
        CommonModule,
        DsIconModule,
        DsModalModule,
        DsProgressCircleModule,
        COMMON_IMPORTS
    ],
  templateUrl: './demo-stock-filters.component.html',
  styleUrl: './demo-stock-filters.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DemoStockFiltersComponent implements OnInit {
  modalData = {
    description: '',
    vin: '',
    storageLocation: '',
  };
  purposeOptions: SelectListOption[] = [];
  brandOptions: { id: string; label: string }[] = [];
  versionOptions: Version[] = [];
  modelOptions: DealerModel[] = [];
  filteredModelOptions: { id: string; label: string }[] = [];
  filteredVersionOptions: { id: string; label: string }[] = [];
  filteredModelOptionsReq: { id: string; label: string }[] = [];
  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'bodyLoading' };
  rowsData: DemoStockRowData[] = [];
  criteriaData: CriteriaResponse = {
    plant: '',
    plantName: '',
    plantCode: '',
    dealerBrands: [],
    dealerModels: [],
    storageLocations: [],
    versions: [],
    errorMessage: '',
    demoOrderingOpen: false,
  };
  demoRequest: DemoVehiclesRequest = {
    iv_user: '',
    plant: '',
    model: '',
    version: '',
    materialNr: [],
  };
  vehicleRequest: RequestVehicleRequest = {
    vin: '',
    dealerCode: '',
    plantCode: '',
    storageLocation: '',
    purpose: '',
  };
  filters = {
    brand: '',
    version: '',
    model: '',
    searchAllDSP: false,
  };
  columnData: DsColumnData[] = [
    {
      field: 'VIN',
      headerName: 'VIN',
    },
    {
      field: 'modelCode',
      headerName: 'Model Code',
    },
    {
      field: 'description',
      headerName: 'Description',
    },
    {
      field: 'interior',
      headerName: 'Interior',
    },
    {
      field: 'exterior',
      headerName: 'Exterior',
    },
    {
      field: 'optionCount',
      headerName: 'Option Count',
    },
    {
      field: 'download',
      headerName: '',
    },
  ];

  constructor(
    private readonly criteriaStoreService: CriteriaStoreService,
    private readonly criteriaService: CriteriaService,
    private readonly demoService: DemoService,
    private toastService: DsToastService,
    private readonly loadingAreaService: DsLoadingAreaService,
    private replenishmentService: ReplenishmentService,
    private readonly userInfoService: UserInfoService
  ) {}

  @Output() filtersChanged = new EventEmitter<DemoVehiclesRequest>();
  dealerStockChecked: boolean = false;
  showTable: boolean = false;
  selectedPurpose: string = '';

  demoStockReplshModalIsOpen: boolean = false;
  isSearchDemoReplenishmentClicked: boolean = false;

  ngOnInit(): void {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.populateDropdowns();
  }

  addToast(tone: 'critical' | 'positive' | 'neutral', teastText: string): void {
    this.toastService.pushToast({
      id: 'error-toast',
      tone: tone,
      toastText: teastText,
    } as DsToastModel);
  }

  private populateDropdowns(): void {
    const criteriaDataStore = this.criteriaStoreService.getCriteriaData();
    if (criteriaDataStore) {
      criteriaDataStore.subscribe((criteriaData) => {
        if (criteriaData) {
          this.criteriaData = criteriaData;
          this.brandOptions = criteriaData.dealerBrands.map((brand) => ({
            id: brand.brandCode,
            label: brand.brandDescription,
          }));
          this.versionOptions = criteriaData.versions;
          this.modelOptions = criteriaData.dealerModels;
        }
      });
    } else {
      const dealerCode = localStorage.getItem('dealerCode') ?? ''; // Default dealer code if not set
      this.criteriaService
        .postCriteriaSelection(dealerCode)
        .subscribe((criteriaData) => {
          this.criteriaData = criteriaData;
          this.criteriaStoreService.setCriteriaData(criteriaData);
          this.brandOptions = criteriaData.dealerBrands.map((brand) => ({
            id: brand.brandCode,
            label: brand.brandDescription,
          }));
        });
    }
    this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
  }

  onBrandChange(event: SelectListOption | SelectListOption[] | null): void {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    if (event && !Array.isArray(event)) {
      this.filters.brand = event.id;
      this.filteredVersionOptions = this.versionOptions
        .filter(
          (version) => String(version.brand) === String(this.filters.brand)
        )
        .map((value) => ({ id: value.version, label: value.version }));
      this.filteredModelOptions = this.modelOptions
        .filter((model) => String(model.brand) === String(this.filters.brand))
        .map((value) => ({
          id: value.modelCode,
          label: value.modelCode + ' - ' + value.profileModelDescription,
        }));
      this.filteredModelOptionsReq = this.filteredModelOptions;
      this.filters.version = '';
      this.filters.model = '';
    } else {
      this.filters.brand = '';
      this.filters.version = '';
      this.filters.model = '';

      this.filteredVersionOptions = [];
      this.filteredModelOptions = [];
      this.filteredModelOptionsReq = [];
      console.error('Invalid event type or null event:', event);
    }
    this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
  }

  onVersionChange(event: SelectListOption | SelectListOption[] | null): void {
    if (event && !Array.isArray(event)) {
      this.filters.version = event.label;
      this.filteredModelOptions = this.modelOptions
        .filter((model) => model.version === this.filters.version)
        .map((model) => ({
          id: model.modelCode,
          label: model.modelCode + ' - ' + model.profileModelDescription,
        }));
      this.filteredModelOptionsReq = this.filteredModelOptions;
      this.onFiltersChange();
      this.filters.model = '';
      this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
    } else {
      this.filters.version = '';
      this.filters.model = '';
      if (this.filters.brand) {
        this.filteredVersionOptions = this.versionOptions
          .filter(
            (version) => String(version.brand) === String(this.filters.brand)
          )
          .map((value) => ({ id: value.version, label: value.version }));

        this.filteredModelOptions = this.modelOptions
          .filter((model) => String(model.brand) === String(this.filters.brand))
          .map((value) => ({
            id: value.modelCode,
            label: value.modelCode + ' - ' + value.profileModelDescription,
          }));

        this.filteredModelOptionsReq = this.filteredModelOptions;
      } else {
        this.filteredVersionOptions = [];
        this.filteredModelOptions = [];
        this.filteredModelOptionsReq = [];
      }
      console.error('Invalid event type or null event:', event);
    }
  }

  onFiltersChange(): void {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    const requestPayload = this.createRequestPayload();
    this.filtersChanged.emit(requestPayload);
    this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
  }

  onModelChange(event: SelectListOption | SelectListOption[] | null): void {
    if (event && !Array.isArray(event)) {
      this.demoRequest.model = event.id;
      this.filters.model = event.id;
      this.filteredModelOptionsReq = [{ id: event.id, label: '' }];
    } else {
      // Model cleared
      this.demoRequest.model = '';
      this.filters.model = '';
      this.filteredModelOptionsReq = this.filteredModelOptions; // fallback to filtered models based on version or brand
    }

    this.onFiltersChange();
  }

  loadDemoStockData(): void {
    this.isSearchDemoReplenishmentClicked = true;
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Demo Stock Data',
    };

    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.demoService.getDemoVehicles(this.createRequestPayload()).subscribe({
      next: (response: StockResponse) => {
        console.log('response', response);
        if (response.ev_message != null && response.ev_message !== '' && response.stock.length < 1 ) {
          this.addToast('critical', response.ev_message);
          this.rowsData = [];
          this.showTable = false;
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          return;
        }
          if (response.errorMessage != null && response.errorMessage !== '' && response.stock.length < 1) {
              this.addToast('critical', response.errorMessage);
              this.rowsData = [];
              this.showTable = false;
              this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
              return;
          }
        if (Array.isArray(response.stock) && response.stock.length > 0) {
          this.rowsData = response.stock.map((item: StockItem) => {
            let interiorFound = false;
            let exteriorFound = false;
            if (Array.isArray(item.options)) {
              for (const element of item.options) {
                if (element.optionIndicator === 'L') {
                  item.exterior = element.optionDescription;
                  exteriorFound = true;
                } else if (element.optionIndicator === 'P') {
                  item.interior = element.optionDescription;
                  interiorFound = true;
                }
                if (interiorFound && exteriorFound) {
                  break;
                }
              }
            }
            return {
              image: '',
              VIN: item.vin,
              modelCode: item.modelCode,
              description: item.profileModelDescription,
              interior: item.interior ?? '',
              exterior: item.exterior ?? '',
              optionCount: item.optionCount,
              options: item.options ?? [],
              download: '',
              storageLocation: item.storageLocation || '',
              plantCode: item.supplyingPlantCode || '',
              version: item.version || '',
            };
          });
        } else {
          this.rowsData = [];
          this.showTable = false;
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          return;
        }
        this.showTable = true;
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
      error: (err: unknown) => {
        console.error('Error loading demo stock data', err);
        this.rowsData = [];
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
    });
  }

  private createRequestPayload(): DemoVehiclesRequest {
    return {
      iv_user: this.userInfoService.getUserId(),
      plant: this.getPlantCode(),
      model: this.filters.model,
      version: this.filters.version,
      materialNr: this.filteredModelOptionsReq.map((option) => option.id),
    };
  }

  private getPlantCode(): string {
    if (this.dealerStockChecked) {
      return this.criteriaData.plant;
    }
    return this.brandOptions[0].label.includes('MOTORRAD') ? 'C202' : 'C203';
  }

  openModal(description: string, vin: string, storageLocation: string): void {
    this.modalData.description = description;
    this.modalData.vin = vin;
    this.modalData.storageLocation = storageLocation;
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.demoService.getPurposeDropdown().subscribe({
      next: (data) => {
        this.purposeOptions = data.map((item) => ({
          id: item['code'],
          label: item['description'],
        }));
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.demoStockReplshModalIsOpen = true;
      },
      error: (error) => {
        console.error('Error fetching purpose options', error);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
    });
  }

  requestVehicle(
    vin: string,
    selectedPurpose: string,
    storageLocation: string
  ): void {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading..',
      loadingText: 'Requesting Vehicle',
    };
    this.vehicleRequest.purpose = selectedPurpose;
    if (!this.vehicleRequest.purpose) {
      this.addToast(
        'critical',
        'Please select a purpose for the vehicle request.'
      );
      return;
    }
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    console.log('Requesting vehicle with VIN:', vin);
    console.log('Selected purpose:', selectedPurpose);
    this.vehicleRequest.vin = vin;
    this.vehicleRequest.dealerCode = localStorage.getItem('dealerCode') ?? '';
    this.vehicleRequest.plantCode = this.getPlantCode();
    this.vehicleRequest.storageLocation = storageLocation;

      this.replenishmentService
        .requestDemoVehicle(this.vehicleRequest)
        .subscribe({
          next: (response) => {
            console.log('Vehicle request successful:', response);
            this.demoStockReplshModalIsOpen = false;
            this.loadingAreaService.removeLoadingArea(
              this.loadingAreaConfig.id
            );
            this.addToast(
              'neutral',
              (response as { messageText: string }).messageText
            );
            this.selectedPurpose = '';
          },
          error: (error) => {
            console.error('Error requesting vehicle:', error);
            this.loadingAreaService.removeLoadingArea(
              this.loadingAreaConfig.id
            );
            this.addToast('critical', 'Demo Request Failed');
          },
        });
  }

  get isBrandSelected(): boolean {
    return !!this.filters.brand;
  }
}
